import { render, staticRenderFns } from "./StoreReceipt.vue?vue&type=template&id=b8d9d760&scoped=true"
import script from "./StoreReceipt.vue?vue&type=script&lang=js"
export * from "./StoreReceipt.vue?vue&type=script&lang=js"
import style0 from "./StoreReceipt.vue?vue&type=style&index=0&id=b8d9d760&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d9d760",
  null
  
)

export default component.exports